export default __webpack_public_path__ + "static/media/icon_arrowdown.2f416631.svg";